exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile-container[data-v-713468c9]{\n\t    margin-top: -25px !important;\n\t    margin-left: -20px;\n\t    width: 103%;\n\t    max-width: 103% !important;\n}\n.page-content[data-v-713468c9]{\n\tpadding: 0!important;\n}\n.page-content > .container-fluid[data-v-713468c9]{\n\tpadding: 0!important;\n}\n.main-content[data-v-713468c9]{\n\tpadding: 0!important;\n}\n\n", ""]);

// exports
